import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreComponent } from './core.component';
import { UserbarComponent } from './userbar/userbar.component';
import { MaterialModule } from '../shared/material-module';
import { NavigationComponent } from './navigation/navigation.component';
import { FooterComponent } from './footer/footer.component';
import { AppModule } from '../app.module';
import { RouterModule } from '@angular/router';
import { NotfoundComponent } from './notfound/notfound.component';
import { LoginComponent } from './login/login.component';
import { AppSettingsService } from './services/app-settings.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthorizationInterceptor } from './services/authorization-interceptor.service';

import { LoadingComponent } from './loading/loading.component';

import { ErrorInterceptor } from './services/error-interceptor.service';
import { SafePipe } from './pipes/safe.pipe';
import { DocumentationViewComponent } from './documentation-view/documentation-view.component';
import { DocumentationNavigationComponent } from './documentation-view/documentation-navigation/documentation-navigation.component';

export function initializeApp(settingsService: AppSettingsService) {
  return () => settingsService.loadSettings();
}

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    HttpClientModule
  ],
  exports : [
    UserbarComponent,
    NavigationComponent,
    FooterComponent,
    NotfoundComponent,
    LoginComponent,
    DocumentationViewComponent,
    LoadingComponent,
    DocumentationNavigationComponent
  ],
  declarations: [
    CoreComponent,
    UserbarComponent,
    NavigationComponent,
    FooterComponent,
    NotfoundComponent,
    LoginComponent,
    DocumentationViewComponent,
    LoadingComponent,
    DocumentationNavigationComponent,
    SafePipe
  ],
  providers : [
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppSettingsService], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor,  multi: true },
  
  ]
  
})
export class CoreModule { }
